import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { message, Modal, Popconfirm, Table, TableProps } from "antd";
import Spinner from "../../components/shared/Spinner/Spinner";
import { ContactUsDataType } from "../../interfaces/admin.interface";
import { ContactsService } from "../../services/contact.service";

const Contact = () => {
  const [contacts, setContacts] = useState<ContactUsDataType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [applyDetails, setApplyDetails] = useState<ContactUsDataType | null>(
    null
  );
  useEffect(() => {
    setLoading(true);
    ContactsService.getAllContacts()
      .then((response) => {
        if (Array.isArray(response?.data?.data)) {
          const dataWithKeys = response?.data?.data?.map(
            (item: ContactUsDataType, index: number) => ({
              ...item,
              key: index + 1,
            })
          );
          setContacts(dataWithKeys);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  const handleDetail = (record: ContactUsDataType) => {
    setIsModalVisible(true);
    setApplyDetails(record);
  };
  const handleDeleteClick = async (record: ContactUsDataType) => {};
  const columns: TableProps<ContactUsDataType>["columns"] = [
    {
      title: "№",
      dataIndex: "key",
      sorter: (a, b) => a.key - b.key,
    },
    {
      title: "Ad",
      dataIndex: "full_name",
      sorter: (a, b) => a.full_name.localeCompare(b.full_name),
    },
    {
      title: "E-poçt",
      dataIndex: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "Nömrə",
      dataIndex: "phone",
    },
    {
      title: "Mesaj",
      dataIndex: "message",
      render: (message: string) => (
        <p>
          {message.length > 15 ? `${message?.substring(0, 15)}...` : message}
        </p>
      ),
    },
    {
      title: (
        <div className="settings">
          <i className="fa-solid fa-gear"></i>
        </div>
      ),
      key: "action",
      render: (_, record) => (
        <div className="settings_icons">
          <div className="add" onClick={() => handleDetail(record)}>
            <i className="fa-regular fa-eye"></i>
          </div>
          <Popconfirm
            title="Bu müraciəti siləcəyinizə əminsiniz?"
            onConfirm={() => handleDeleteClick(record)}
            onCancel={() => message.info("Silmə əməliyyatı ləğv edildi.")}
            okText="Bəli"
            cancelText="Xeyr"
            placement="topRight"
          >
            <div className="delete">
              <i className="fa-solid fa-trash"></i>
            </div>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div id="pages">
      <Helmet>
        <title>Orhan Door | Müştəri müraciətləri</title>
      </Helmet>
      {loading ? (
        <Spinner />
      ) : (
        <div>
          <div className="page_head">
            <h3 className="page_title">Müştəri müraciətləri</h3>
          </div>
          <div className="pages_components">
            <div className="pages_table">
              <Table
                scroll={{ x: "100%" }}
                columns={columns}
                dataSource={contacts}
                rowKey={(record) => record.id.toString()}
                pagination={false}
              />
            </div>
          </div>
        </div>
      )}
      <Modal
        title={"Təmir üçün müraciətin detalları"}
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        style={{ minWidth: "340px" }}
        centered
      >
        <div className="details">
          <h1 className="full_name">{applyDetails?.full_name}</h1>
          <div className="info">
            <h3 className="title">Əlaqə məlumatları</h3>
            <div className="info_detail">
              <p className="subtitle">Nömrə:</p>
              <a className="content" href={`tel:${applyDetails?.phone}`}>
                {applyDetails?.phone}
              </a>
            </div>
            <div className="info_detail">
              <p className="subtitle">E-poçt:</p>
              <a
                className="content"
                href={`mailto:${applyDetails?.email}?subject=Support Request&body=Hello,`}
              >
                {applyDetails?.email}
              </a>
            </div>
          </div>

          <div className="info">
            <h3 className="title">Müraciət</h3>
            <div className="info_detail">
              <p className="subtitle">Mesaj:</p>
              <p className="content">{applyDetails?.message}</p>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Contact;
